<template>
  <button
    class="checkbox"
    :class="{'checkbox--active': value}"
    type="button"
    @click.stop="toggleCheck"
  >
    <div class="checkbox__icon">
      <div class="checkbox__placeholder">
        <CheckSVG />
      </div>
    </div>

    <span v-if="$slots.default">
      <slot />
    </span>
  </button>
</template>

<script>
import CheckSVG from '@/components/svg/CheckSVG'

export default {
  props: ['value'],

  components: {
    CheckSVG,
  },

  methods: {
    toggleCheck () {
      this.$emit('input', !this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
  .checkbox {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: transparent;
    cursor: pointer;
    text-align: left;;

    &__icon {
      flex: 0 0 auto;
      display: inline-flex;
      align-items: stretch;
      width: 25px;
      height: 25px;
      border: 2px solid #ff8000;
      border-radius: 5px;
    }

    &__placeholder {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      border-radius: 3px;
      background: #ff8000;
      opacity: 0;

      /deep/ svg {
        width: 80%;
        fill: #fff;
      }
    }

    &--active &__placeholder {
      opacity: 1;
    }
  }
</style>